export const DPReport = { url: 'https://app.sigmacomputing.com/embed/1-4co6183ButSHotomH6AHxv' }
export const PL = {
  url: 'https://app.sigmacomputing.com/embed/1-2Q73U2ig9WFJPckLf300jk',
  params: { menu_position: 'none' },
}
export const Daily = { url: 'https://app.sigmacomputing.com/embed/1-2Xynl20pURhEt6IZnXE79n' }
export const NewContractsReport = {
  url: 'https://app.sigmacomputing.com/embed/1-6EDa4puF0rMXaUvz1sxCL3',
  params: { menu_position: 'none' },
}
export const UnshippedReport = {
  url: 'https://app.sigmacomputing.com/embed/1-2yvJICAlbFzcMuLL3MJQ3r',
  params: { menu_position: 'none' },
}
